import { ApiClient } from "@/typescript/api_client/client_interface";
import { AxiosRequestConfig, AxiosResponse, AxiosProxyConfig } from "axios";
import axios from "axios";

export class EmeshApiClient implements ApiClient {
  baseUrl: string = process.env.VUE_APP_EMESH_API;
  apiPath: string;

  constructor(apiPath: string) {
    this.apiPath = this.baseUrl + apiPath;
  }

  async get(config: AxiosRequestConfig): Promise<AxiosResponse> {
    return await axios
      .get(this.apiPath, config)
      .then(res => {
        return res;
      })
      .catch(e => {
        // エラーレスポンスが存在する場合はエラーレスポンスを返却する
        if (e.response) return Promise.reject(e.response);

        // @TODO: 予期せぬエラーの場合にどのような処理をするか考慮する必要がある
        return Promise.reject(e);
      });
  }

  async post(config: AxiosRequestConfig, data?: any): Promise<AxiosResponse> {
    try {
      // Content-Type にて指定されている場合は x-www-form-urlencoded 形式で POST する
      if (config.headers["Content-Type"] === "x-www-form-urlencoded") {
        return await axios.post(this.apiPath, data);
      }
      return await axios.post(this.apiPath, data, config);
    } catch (e) {
      // エラーレスポンスが存在する場合はエラーレスポンスを返却する
      if (e.response) return Promise.reject(e.response);

      // @TODO: 予期せぬエラーの場合にどのような処理をするか考慮する必要がある
      return Promise.reject(e);
    }
  }

  async delete(config: AxiosRequestConfig): Promise<AxiosResponse> {
    return await axios
      .delete(this.apiPath, config)
      .then(res => {
        return res;
      })
      .catch(e => {
        // エラーレスポンスが存在する場合はエラーレスポンスを返却する
        if (e.response) return Promise.reject(e.response);

        // @TODO: 予期せぬエラーの場合にどのような処理をするか考慮する必要がある
        return Promise.reject(e);
      });
  }
}
